export default __webpack_public_path__ + "./images/iq.e708b1c4.png";